(function () {
  if (window.customElements.get("lampshade-product-builder")) {
    return;
  }

  const normalise = (value) => String(value || "").trim().toLowerCase();

  const normaliseSize = (value) => {
    const normalized = normalise(value).replace(/[”″]/g, '"').replace(/[’′]/g, "'");
    const numericMatch = normalized.match(/\d+(?:\.\d+)?/);

    return numericMatch ? numericMatch[0] : normalized;
  };

  const parseJson = (element, fallback) => {
    try {
      const parsed = JSON.parse(element?.textContent || "");
      return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
    } catch (_error) {
      return fallback;
    }
  };

  const escapeHtml = (value) => String(value || "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  })[character]);

  const formatSizeLabel = (value) => String(value || "")
    .replace(/(\d+(?:\.\d+)?")\s+(base|slope|top|height)\b/gi, (_match, measurement, label) => (
      `${measurement} ${label.charAt(0).toUpperCase()}${label.slice(1).toLowerCase()}`
    ))
    .replace(/\s+(?=\d+(?:\.\d+)?"\s+(?:Base|Slope|Top|Height)\b)/g, (space, offset, label) => {
      const previousText = label.slice(0, offset).trimEnd().toLowerCase();

      return previousText.endsWith("x") || previousText.endsWith("-") ? space : " - ";
    });

  const uniqueLabels = (...labels) => {
    const seen = new Set();

    return labels
      .map((label) => String(label || "").trim())
      .filter((label) => {
        if (!label) {
          return false;
        }

        const normalizedLabel = normalise(label);

        if (seen.has(normalizedLabel)) {
          return false;
        }

        seen.add(normalizedLabel);
        return true;
      });
  };

  const formatSwatchImagePart = (value) => String(value || "")
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^A-Za-z0-9_-]/g, "");

  const formatSwatchImageShapePart = (value) => formatSwatchImagePart(value)
    .replace(/-/g, "_")
    .replace(/(^|[_-])([a-z])/g, (_match, separator, character) => `${separator}${character.toUpperCase()}`);

  const optionIdFromLabel = (value) => String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[”″]/g, "inch")
    .replace(/[’′]/g, "ft")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

  const addImageIdentifier = (url, identifier) => {
    const formattedIdentifier = formatSwatchImagePart(identifier);

    if (!url || !formattedIdentifier) {
      return url;
    }

    return url.replace(/(\.[A-Za-z0-9]+)(\?.*)?$/, `_${formattedIdentifier}$1$2`);
  };

  const swatchImageFromTemplate = (template, shapeLabel, finishLabel, optionLabel, imageIdentifier) => {
    if (!template || !finishLabel || !optionLabel) {
      return "";
    }

    if (template.includes("{shape}") && !shapeLabel) {
      return "";
    }

    const imageUrl = template
      .replace(/\{shape\}/g, encodeURIComponent(formatSwatchImageShapePart(shapeLabel)))
      .replace("{finish}", encodeURIComponent(formatSwatchImagePart(finishLabel)))
      .replace("{option}", encodeURIComponent(formatSwatchImagePart(optionLabel)));

    return addImageIdentifier(imageUrl, imageIdentifier);
  };

  const stitchingGalleryImageFromDataset = (dataset, stitchingId) => {
    if (stitchingId === "stitched-leather") {
      return dataset.stitchingLeatherGalleryImage || "";
    }

    if (stitchingId === "stitched-cotton") {
      return dataset.stitchingCottonGalleryImage || "";
    }

    return "";
  };

  const stitchingGalleryImageDimensions = (stitchingId) => {
    if (stitchingId === "stitched-leather") {
      return { width: 1000, height: 1500 };
    }

    if (stitchingId === "stitched-cotton") {
      return { width: 1000, height: 1460 };
    }

    return { width: 1000, height: 1500 };
  };

  const shouldSyncStitchingGallery = () => {
    const mediaQuery = window.themeVariables?.mediaQueries?.md || "screen and (min-width: 1000px)";

    return window.matchMedia(mediaQuery).matches;
  };

  const swatchImageShapeFromProductType = (productType) => {
    const firstShape = Array.isArray(productType?.shapes) ? productType.shapes[0] : null;

    if (typeof firstShape === "string") {
      return firstShape;
    }

    return firstShape?.imageTemplateShape || firstShape?.swatchImageShape || firstShape?.shape || productType?.swatchImageShape || productType?.id || productType?.label || "";
  };

  const defaultFinishOptions = {
    card: [
      { id: "perga-parchment", label: "Perga Parchment", swatch: { color: "#d8c7a8" } },
      { id: "china-white", label: "China White", swatch: { color: "#fffdf5" } },
      { id: "snow-white", label: "Snow White", swatch: { color: "#f7f5ef" } },
      { id: "black-patent", label: "Black Patent", swatch: { color: "#111111" } },
      { id: "burgundy-patent", label: "Burgundy Patent", swatch: { color: "#5b1624" } },
      { id: "boiserie-radica-ulivo", label: "Boiserie Radica Ulivo" }
    ],
    linen: [
      { id: "white", label: "White", swatch: { color: "#f8f6ef", imageIdentifierByShape: { empire: "Custom" } } },
      { id: "ecru", label: "Ecru", swatch: { color: "#d8cab1" } },
      { id: "natural-glazed-linen", label: "Natural Glazed Linen", swatch: { color: "#b9aa90" } }
    ],
    raffia: [],
    silk: [
      { id: "white", label: "White", swatch: { color: "#f8f6ef" } },
      { id: "warm-white", label: "Warm White", swatch: { color: "#efe7d2" } },
      { id: "plover", label: "Plover", swatch: { color: "#9b9287" } },
      { id: "pot-pourri", label: "Pot Pourri", swatch: { color: "#b8908b" } },
      { id: "french-grey", label: "French Grey", swatch: { color: "#8d9191" } },
      { id: "nordic-blue", label: "Nordic Blue", swatch: { color: "#596c7f" } }
    ]
  };

  const defaultLinings = [
    { id: "matt-gold", label: "Matt Gold", swatch: { color: "#b79a56" } },
    { id: "gloss-gold", label: "Gloss Gold", swatch: { color: "#d4af37" } },
    { id: "matt-silver", label: "Matt Silver", swatch: { color: "#b8b8b0" } },
    { id: "none", label: "None", price: 0, swatch: { empty: true } }
  ];

  const defaultStitching = [
    { id: "none", label: "None", swatch: { empty: true } },
    { id: "stitched-leather", label: "Leather", finishIds: ["card"], finishLabels: ["Card - Stitched Leather", "Card Stitched Leather"], swatch: {} },
    { id: "stitched-cotton", label: "Cotton", finishIds: ["card"], finishLabels: ["Card - Stitched Cotton", "Card Stitched Cotton"], swatch: {} }
  ];
  const empireStitchingFinishOptionIds = new Set(["perga-parchment", "china-white", "snow-white"]);

  const defaultFittings = [
    { id: "known", label: "I know the fitting required" },
    { id: "unknown", label: "I don't know the fitting required" }
  ];

  const normalizeMatrix = (matrix, swatchImageTemplate = "") => {
    if (!matrix) {
      return matrix;
    }

    const hasCombinedRaffiaSilk = matrix.finishes?.some((finish) => finish.id === "raffia-silk");
    const hasSeparateRaffiaSilk = matrix.finishes?.some((finish) => finish.id === "raffia" || finish.id === "silk");

    if (hasCombinedRaffiaSilk && !hasSeparateRaffiaSilk) {
      matrix.finishes = matrix.finishes.flatMap((finish) => {
        if (finish.id !== "raffia-silk") {
          return [finish];
        }

        return [
          { id: "raffia", label: "Raffia", variantLabels: ["Raffia", finish.label] },
          { id: "silk", label: "Silk", variantLabels: ["Silk", finish.label] }
        ];
      });
    }

    matrix.productTypes = (matrix.productTypes || []).map((productType) => ({
      ...productType,
      swatchImageShape: swatchImageShapeFromProductType(productType)
    }));

    matrix.finishes = (matrix.finishes || []).map((finish) => {
      const defaultOptions = defaultFinishOptions[finish.id] || [];
      const options = finish.options?.length ? finish.options : defaultOptions;
      const optionIds = new Set(options.map((option) => option.id));
      const optionsWithDefaults = options.concat(defaultOptions.filter((option) => !optionIds.has(option.id)));
      const defaultOrder = new Map(defaultOptions.map((option, index) => [option.id, index]));
      const orderedOptions = finish.id === "card"
        ? [...optionsWithDefaults].sort((a, b) => (
          (defaultOrder.get(a.id) ?? optionsWithDefaults.indexOf(a)) - (defaultOrder.get(b.id) ?? optionsWithDefaults.indexOf(b))
        ))
        : optionsWithDefaults;

      return {
        ...finish,
        options: orderedOptions.map((option) => {
          const normalizedOption = {
            ...defaultOptions.find((defaultOption) => defaultOption.id === option.id),
            ...option
          };
          const image = normalizedOption.swatch?.image;

          return {
            ...normalizedOption,
            swatch: {
              ...(normalizedOption.swatch || {}),
              ...(image ? { image } : {}),
              ...(!image && swatchImageTemplate ? { imageTemplate: swatchImageTemplate } : {})
            }
          };
        })
      };
    });

    if (!matrix.linings?.length || matrix.linings.some((lining) => lining.id === "lining" || normalise(lining.label) === "yes" || normalise(lining.label) === "no")) {
      matrix.linings = defaultLinings;
    }

    matrix.linings = (matrix.linings || []).map((lining) => ({
      ...defaultLinings.find((defaultLining) => defaultLining.id === lining.id),
      ...lining
    }));

    if (!matrix.stitching?.length) {
      matrix.stitching = defaultStitching;
    }

    matrix.stitching = (matrix.stitching || []).map((stitching) => ({
      ...defaultStitching.find((defaultOption) => defaultOption.id === stitching.id),
      ...stitching
    }));

    if (!matrix.fittings?.length) {
      matrix.fittings = defaultFittings;
    }

    matrix.fittings = (matrix.fittings || []).map((fitting) => ({
      ...defaultFittings.find((defaultOption) => defaultOption.id === fitting.id),
      ...fitting
    }));

    (matrix.productTypes || []).forEach((productType) => {
      (productType.sizes || []).forEach((size) => {
        if (size.prices?.["raffia-silk"] != null) {
          size.prices.raffia = size.prices["raffia-silk"];
          size.prices.silk = size.prices["raffia-silk"];
        }

        if (size.liningPrices?.["card-lining"] != null) {
          size.liningPrices["matt-gold"] = size.liningPrices["card-lining"];
          size.liningPrices["gloss-gold"] = size.liningPrices["card-lining"];
          size.liningPrices["matt-silver"] = size.liningPrices["card-lining"];
        }
      });
    });

    return matrix;
  };

  const formatMoney = (cents, moneyFormat) => {
    if (window.Shopify?.formatMoney) {
      return window.Shopify.formatMoney(cents, moneyFormat || window.themeVariables?.settings?.moneyFormat);
    }

    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP"
    }).format(cents / 100);
  };

  const normalizeVariant = (variant) => ({
    id: variant.id,
    title: variant.title,
    available: variant.available,
    price: variant.price,
    sku: variant.sku,
    options: variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean)
  });

  class LampshadeProductBuilder extends HTMLElement {
    connectedCallback() {
      this.matrix = normalizeMatrix(
        parseJson(this.querySelector("[data-lampshade-builder-matrix]"), {}),
        this.dataset.swatchImageTemplate
      );
      this.variants = parseJson(this.querySelector("[data-lampshade-builder-variants]"), []);
      this.form = document.getElementById(this.dataset.formId);
      this.idInput = this.form?.querySelector('[name="id"]');
      this.stepsContainer = this.querySelector("[data-builder-steps]");
      this.statusElement = this.querySelector("[data-builder-status]");
      this.titleElement = this.querySelector("[data-builder-title]");
      this.summaryElement = this.querySelector("[data-builder-summary]");
      this.summarySalePriceElement = this.querySelector("[data-builder-summary-sale-price]");
      this.summaryPriceElement = this.querySelector("[data-builder-summary-price]");
      this.enquirySubmit = this.querySelector("[data-builder-enquiry-submit]");
      this.priceElement = document.querySelector(`[data-builder-price][data-builder-form-id="${this.dataset.formId}"]`) || this.querySelector("[data-builder-price]");
      this.moneyFormat = this.dataset.moneyFormat;
      this.state = {};
      this.selectedBaseVariant = null;
      this.selectedEnquiryVariant = null;
      this.hasInteractedWithStitching = false;

      if (!this.form || !this.idInput || !this.stepsContainer || !this.matrix?.productTypes?.length) {
        this.setStatus("Builder setup is incomplete. Please check the product form and pricing data.", "error");
        this.setSubmitState(false);
        return;
      }

      if (this.matrix.productTypes.length === 1) {
        this.state.shape = this.matrix.productTypes[0].id;
      }

      this.renderSteps();
      this.addEventListener("click", this.onClick.bind(this));
      this.addEventListener("change", this.onChange.bind(this));
      this.addEventListener("keydown", this.onKeyDown.bind(this));
      this.form.addEventListener("submit", this.onSubmit.bind(this), true);
      this.enquirySubmit?.addEventListener("click", this.onEnquiryClick.bind(this));
      this.galleryMediaQueryList = window.matchMedia(window.themeVariables?.mediaQueries?.md || "screen and (min-width: 1000px)");
      this.onGalleryMediaQueryChange = () => this.syncStitchingGalleryImage();

      if ("addEventListener" in this.galleryMediaQueryList) {
        this.galleryMediaQueryList.addEventListener("change", this.onGalleryMediaQueryChange);
      } else {
        this.galleryMediaQueryList.addListener(this.onGalleryMediaQueryChange);
      }

      this.renderSizeOptions();
      this.applyDefaultSelections();
      this.updateActiveOptionStates();
      this.update();
      this.syncStitchingGalleryImage();
      this.loadProductVariants();
    }

    disconnectedCallback() {
      if (!this.galleryMediaQueryList || !this.onGalleryMediaQueryChange) {
        return;
      }

      if ("removeEventListener" in this.galleryMediaQueryList) {
        this.galleryMediaQueryList.removeEventListener("change", this.onGalleryMediaQueryChange);
      } else {
        this.galleryMediaQueryList.removeListener(this.onGalleryMediaQueryChange);
      }
    }

    async loadProductVariants() {
      if (!this.dataset.productHandle) {
        return;
      }

      try {
        const response = await fetch(`/products/${this.dataset.productHandle}.js`, {
          headers: { Accept: "application/json" }
        });

        if (!response.ok) {
          return;
        }

        const product = await response.json();
        const variants = Array.isArray(product?.variants) ? product.variants.map(normalizeVariant) : [];

        if (!variants.length) {
          return;
        }

        const previousState = { ...this.state };
        this.variants = variants;
        this.state = previousState;
        this.renderSteps();
        this.renderSizeOptions();
        this.renderFinishOptions();
        this.renderFinishOptionOptions();
        this.renderStitchingOptions();
        this.syncInputsFromState();
        this.applyDefaultSelections();
        this.updateActiveOptionStates();
        this.update();
      } catch (_error) {
        // The embedded Liquid variant data is still used if the Ajax product endpoint is unavailable.
      }
    }

    renderSteps() {
      const steps = [
        {
          key: "shape",
          label: "Shape",
          values: this.matrix.productTypes.map((type) => ({
            id: type.id,
            label: type.label
          }))
        },
        {
          key: "size",
          label: "Size",
          values: []
        },
        {
          key: "finish",
          label: "Finish & Option",
          values: this.availableFinishes()
        },
        {
          key: "stitching",
          label: "Stitching",
          values: this.availableStitchingOptions()
        },
        {
          key: "lining",
          label: "Lining",
          values: this.matrix.linings || []
        },
        {
          key: "fitting",
          label: "Fitting",
          values: this.matrix.fittings || []
        }
      ].filter((step) => {
        if (step.key === "shape" && this.matrix.productTypes.length <= 1) {
          return false;
        }

        if (step.key === "stitching" && !this.shouldShowStitchingStep()) {
          return false;
        }

        return step.values.length > 0 || step.key === "size";
      });

      this.stepsContainer.innerHTML = steps.map((step) => this.renderStep(step)).join("");
    }

    refreshStepsPreservingOpen() {
      const openStepKeys = new Set(
        Array.from(this.querySelectorAll(".lampshade-builder__step[open]"))
          .map((step) => step.dataset.step)
          .filter(Boolean)
      );

      this.renderSteps();
      this.renderSizeOptions();
      this.renderFinishOptions();
      this.renderFinishOptionOptions();
      this.renderStitchingOptions();
      this.syncInputsFromState();
      this.updateActiveOptionStates();

      this.querySelectorAll(".lampshade-builder__step").forEach((step) => {
        if (openStepKeys.has(step.dataset.step)) {
          step.open = true;
        }
      });
    }

    renderStep(step) {
      return `
        <details class="lampshade-builder__step" data-step="${step.key}" ${step.key === "size" ? "open" : ""}>
          <summary class="lampshade-builder__step-summary">
            <span>${escapeHtml(step.label)}</span>
            <span class="lampshade-builder__step-value" data-step-value="${step.key}">Required</span>
            <span class="lampshade-builder__step-icon" aria-hidden="true"></span>
          </summary>
          <fieldset class="lampshade-builder__fieldset" aria-label="${escapeHtml(step.label)}">
            ${this.renderStepControls(step)}
          </fieldset>
        </details>
      `;
    }

    renderStepControls(step) {
      if (step.key === "finish") {
        return `
          <div class="lampshade-builder__tabs" role="radiogroup" aria-label="${escapeHtml(step.label)}" data-step-options="finish">
            ${step.values.map((option) => this.renderOption("finish", option, "tab")).join("")}
          </div>
          ${this.renderSwatchGrid("finishOption", [])}
          <p class="lampshade-builder__selected-description text-sm" data-selected-description="finishOption" hidden></p>
        `;
      }

      if (step.key === "lining") {
        return `
          ${this.renderSwatchGrid("lining", step.values)}
          <p class="lampshade-builder__selected-description text-sm" data-selected-description="lining" hidden></p>
        `;
      }

      if (step.key === "stitching") {
        return `
          <div class="lampshade-builder__options" data-step-options="stitching">
            ${step.values.map((option) => this.renderOption("stitching", option)).join("")}
          </div>
          <p class="lampshade-builder__selected-description text-sm" data-selected-description="stitching" hidden></p>
        `;
      }

      if (step.key === "fitting") {
        return `
          <div class="lampshade-builder__options" data-step-options="fitting">
            ${step.values.map((option) => this.renderOption("fitting", option)).join("")}
          </div>
          <a class="lampshade-builder__guide-link" href="https://cdn.shopify.com/s/files/1/0911/9727/6546/files/Paolo_Moschino_Ltd._-_Lampshade_Fittings_Guide-August.pdf?v=1786633058" target="_blank" rel="noopener">
            <span class="lampshade-builder__guide-icon" aria-hidden="true">
              <svg focusable="false" fill="none" width="17" viewBox="0 0 17 20">
                <path d="M4.25 1.5h5.5L14.5 6.25V18.5H4.25z" stroke="currentColor" stroke-linejoin="round"/>
                <path d="M9.75 1.5v4.75h4.75M6.5 10h5.75M6.5 13h5.75M6.5 16h3.75" stroke="currentColor" stroke-linecap="square"/>
              </svg>
            </span>
            <span>View our fitting guide</span>
            <span class="lampshade-builder__guide-arrow" aria-hidden="true">
              <svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                <path d="M0 5H16" stroke="currentColor" stroke-width="1"></path>
                <path d="M12 1L16 5L12 9" stroke="currentColor" stroke-width="1"></path>
              </svg>
            </span>
          </a>
        `;
      }

      return `
        <div class="lampshade-builder__options" data-step-options="${step.key}">
          ${step.values.map((option) => this.renderOption(step.key, option)).join("")}
        </div>
      `;
    }

    renderSwatchGrid(stepKey, values) {
      const gridLabel = stepKey === "finishOption" ? "finish options" : `${stepKey} options`;

      return `
        <div class="lampshade-builder__swatch-grid-shell" role="group" aria-label="${escapeHtml(gridLabel)}">
          <div class="lampshade-builder__options lampshade-builder__swatch-grid" data-step-options="${stepKey}">
            ${values.map((option) => this.renderOption(stepKey, option)).join("")}
          </div>
        </div>
      `;
    }

    renderOption(stepKey, option, presentation) {
      const id = `${this.dataset.formId}-${stepKey}-${option.id}`;
      const isSwatch = stepKey === "finishOption" || stepKey === "lining" || stepKey === "stitching";
      const isEmptySwatch = Boolean(option.swatch?.empty);
      const swatchImage = option.swatch?.image || this.swatchImageForOption(stepKey, option);
      const hasImageSwatch = Boolean(swatchImage);
      const hasCssStitchingSwatch = stepKey === "stitching" && !isEmptySwatch;
      const isTab = presentation === "tab";
      const swatchStyle = [
        !hasImageSwatch && option.swatch?.color ? `background-color: ${escapeHtml(option.swatch.color)};` : ""
      ].filter(Boolean).join(" ");
      const swatchImageMarkup = hasImageSwatch
        ? `<img class="lampshade-builder__swatch-image" src="${escapeHtml(swatchImage)}" alt="" loading="lazy" decoding="async">`
        : "";

      const optionMarkup = `
        <label class="lampshade-builder__option ${isSwatch ? "lampshade-builder__option--swatch" : ""} ${isTab ? "lampshade-builder__option--tab" : ""}" for="${escapeHtml(id)}" ${isSwatch ? `data-swatch-label="${escapeHtml(option.label)}"` : ""}>
          <input id="${escapeHtml(id)}" type="radio" name="${escapeHtml(this.dataset.formId)}-${stepKey}" value="${escapeHtml(option.id)}" data-builder-choice="${stepKey}">
          ${isSwatch ? `<span class="lampshade-builder__swatch ${hasImageSwatch ? "lampshade-builder__swatch--image" : ""} ${swatchStyle || hasImageSwatch || hasCssStitchingSwatch ? "" : "lampshade-builder__swatch--placeholder"} ${isEmptySwatch ? "lampshade-builder__swatch--empty" : ""}" style="${swatchStyle}" aria-hidden="true">${swatchImageMarkup}</span>` : ""}
          <span class="lampshade-builder__option-label">${escapeHtml(option.label)}</span>
        </label>
      `;

      if (stepKey !== "stitching" || !stitchingGalleryImageFromDataset(this.dataset, option.id)) {
        return optionMarkup;
      }

      return `
        <div class="lampshade-builder__option-with-detail">
          ${optionMarkup}
          <button type="button" class="lampshade-builder__stitching-detail-link" data-builder-stitching-detail data-builder-stitching-detail-option="${escapeHtml(option.id)}">
            View ${escapeHtml(option.label)}
          </button>
        </div>
      `;
    }

    swatchImageForOption(stepKey, option) {
      if (stepKey !== "finishOption" || !option.swatch?.imageTemplate) {
        return "";
      }

      const selectedShape = this.selectedShape();
      const shapeIdentifier = option.swatch.imageIdentifierByShape?.[normalise(selectedShape?.id)]
        || option.swatch.imageIdentifierByShape?.[normalise(selectedShape?.swatchImageShape)]
        || option.swatch.imageIdentifier;

      return swatchImageFromTemplate(
        option.swatch.imageTemplate,
        selectedShape?.swatchImageShape,
        this.selectedFinish()?.label,
        option.label,
        shapeIdentifier
      );
    }

    applyDefaultSelections(options = {}) {
      const selectFinishOption = options.selectFinishOption !== false;

      this.applySelectedVariantDefaults();

      if (!this.state.size) {
        const firstSize = this.querySelector('[data-builder-choice="size"]');

        if (firstSize) {
          firstSize.checked = true;
          this.state.size = firstSize.value;
        }
      }

      ["finish", "lining", "fitting"].forEach((key) => {
        if (this.state[key]) {
          return;
        }

        const firstInput = {
          lining: this.querySelector('[data-builder-choice="lining"][value="none"]') || this.querySelector('[data-builder-choice="lining"]'),
          fitting: this.querySelector('[data-builder-choice="fitting"][value="known"]') || this.querySelector('[data-builder-choice="fitting"]')
        }[key] || this.querySelector(`[data-builder-choice="${key}"]`);

        if (firstInput) {
          firstInput.checked = true;
          this.state[key] = firstInput.value;
        }
      });

      this.renderFinishOptionOptions();

      if (selectFinishOption && !this.state.finishOption) {
        const firstFinishOption = this.querySelector('[data-builder-choice="finishOption"]');

        if (firstFinishOption) {
          firstFinishOption.checked = true;
          this.state.finishOption = firstFinishOption.value;
        }
      }

      this.renderStitchingOptions();
      if (this.shouldShowStitchingStep() !== Boolean(this.querySelector('[data-step-options="stitching"]'))) {
        this.refreshStepsPreservingOpen();
      }
      this.applyDefaultStitchingSelection();
    }

    applySelectedVariantDefaults() {
      const variant = this.currentFormVariant();
      const [sizeLabel, finishLabel] = variant?.options || [];

      if (sizeLabel && !this.state.size) {
        const size = this.availableSizes().find((candidate) => (
          normaliseSize(this.sizeOptionLabel(candidate)) === normaliseSize(sizeLabel)
        ));

        this.checkChoice("size", size?.id);
      }

      if (finishLabel && !this.state.finish) {
        const finish = this.availableFinishes().find((candidate) => {
          const labels = [candidate.label].concat(candidate.variantLabels || []);
          const stitchingLabels = (this.matrix.stitching || []).flatMap((stitching) => (
            stitching.finishIds?.includes(candidate.id) ? stitching.finishLabels || [] : []
          ));

          labels.push(...stitchingLabels);

          return labels.some((label) => normalise(label) === normalise(finishLabel));
        });

        this.checkChoice("finish", finish?.id);
      }

      if (finishLabel && !this.state.stitching) {
        const stitching = (this.matrix.stitching || []).find((candidate) => (
          candidate.id !== "none" && (candidate.finishLabels || []).some((label) => normalise(label) === normalise(finishLabel))
        ));

        this.state.stitching = stitching?.id || this.state.stitching;
      }
    }

    currentFormVariant() {
      const variantId = Number(this.idInput?.value || new URLSearchParams(window.location.search).get("variant") || 0);

      return this.variants.find((variant) => Number(variant.id) === variantId) || this.variants[0] || null;
    }

    checkChoice(stepKey, value) {
      if (!value) {
        return;
      }

      const input = Array.from(this.querySelectorAll(`[data-builder-choice="${stepKey}"]`))
        .find((choice) => choice.value === String(value));

      if (!input) {
        return;
      }

      input.checked = true;
      this.state[stepKey] = input.value;
    }

    syncInputsFromState() {
      Object.entries(this.state).forEach(([stepKey, value]) => {
        this.checkChoice(stepKey, value);
      });

      this.updateActiveOptionStates();
    }

    updateActiveOptionStates() {
      this.querySelectorAll(".lampshade-builder__option").forEach((option) => {
        const input = option.querySelector("[data-builder-choice]");
        const isSelected = Boolean(input?.checked);

        option.classList.toggle("is-selected", isSelected);
        option.toggleAttribute("data-selected", isSelected);
      });
    }

    onChange(event) {
      const input = event.target.closest("[data-builder-choice]");

      if (!input) {
        return;
      }

      const choiceKey = input.dataset.builderChoice;

      this.state[choiceKey] = input.value;

      if (choiceKey === "shape") {
        delete this.state.size;
        delete this.state.finish;
        delete this.state.finishOption;
        delete this.state.stitching;
        this.hasInteractedWithStitching = false;
        this.renderSizeOptions();
        this.refreshStepsPreservingOpen();
        this.renderFinishOptionOptions();
        this.renderStitchingOptions();
        this.applyDefaultSelections();
      }

      if (choiceKey === "finish") {
        delete this.state.finishOption;
        delete this.state.stitching;
        this.hasInteractedWithStitching = false;
        this.renderFinishOptionOptions();
        this.renderStitchingOptions();
        this.applyDefaultSelections({ selectFinishOption: false });
      }

      if (choiceKey === "stitching") {
        this.hasInteractedWithStitching = true;
      }

      if (["size", "finishOption", "lining"].includes(choiceKey)) {
        this.refreshStepsPreservingOpen();
        this.renderFinishOptionOptions();
        this.renderStitchingOptions();
        this.applyDefaultStitchingSelection();
      }

      this.syncInputsFromState();
      this.updateActiveOptionStates();
      this.update();
      this.syncStitchingGalleryImage();
      this.openNextStep(choiceKey);
    }

    onClick(event) {
      const stitchingDetailButton = event.target.closest("[data-builder-stitching-detail]");
      const stitchingDetailClose = event.target.closest("[data-builder-stitching-detail-close]");
      const stitchingLightbox = event.target.closest("[data-builder-stitching-lightbox]");

      if (stitchingDetailButton) {
        event.preventDefault();
        event.stopPropagation();
        this.openStitchingDetailLightbox(stitchingDetailButton.dataset.builderStitchingDetailOption);
        return;
      }

      if (stitchingDetailClose || event.target === stitchingLightbox) {
        event.preventDefault();
        this.closeStitchingDetailLightbox();
        return;
      }

      const input = event.target.closest("[data-builder-choice]");

      if (
        !input ||
        input.dataset.builderChoice === "finish" ||
        !input.checked ||
        this.state[input.dataset.builderChoice] !== input.value
      ) {
        return;
      }

      this.openNextStep(input.dataset.builderChoice);
    }

    renderSizeOptions() {
      const shape = this.selectedShape();
      const container = this.querySelector('[data-step-options="size"]');

      if (!container) {
        return;
      }

      const sizes = this.availableSizes();

      container.innerHTML = sizes
        .map((size) => this.renderOption("size", {
          id: size.id,
          label: size.optionLabel || size.variantLabel || size.label
        }))
        .join("");

      if (this.state.size && !sizes.some((size) => size.id === this.state.size)) {
        delete this.state.size;
      }
    }

    renderFinishOptions() {
      const container = this.querySelector('[data-step-options="finish"]');

      if (!container) {
        return;
      }

      const finishes = this.availableFinishes();

      container.innerHTML = finishes.map((option) => this.renderOption("finish", option, "tab")).join("");

      if (this.state.finish && !finishes.some((finish) => finish.id === this.state.finish)) {
        delete this.state.finish;
        delete this.state.finishOption;
        delete this.state.stitching;
      }
    }

    renderFinishOptionOptions() {
      const container = this.querySelector('[data-step-options="finishOption"]');

      if (!container) {
        return;
      }

      container.innerHTML = (this.selectedFinish()?.options || [])
        .map((option) => this.renderOption("finishOption", option))
        .join("");
    }

    renderStitchingOptions() {
      const container = this.querySelector('[data-step-options="stitching"]');

      if (!container) {
        if (!this.shouldShowStitchingStep()) {
          delete this.state.stitching;
        }

        return;
      }

      const options = this.availableStitchingOptions();
      container.innerHTML = options.map((option) => this.renderOption("stitching", option)).join("");

      if (!options.some((option) => option.id === this.state.stitching)) {
        delete this.state.stitching;
      }
    }

    selectedShape() {
      return (this.matrix.productTypes || []).find((type) => type.id === this.state.shape);
    }

    selectedSize() {
      return this.availableSizes().find((size) => size.id === this.state.size);
    }

    selectedFinish() {
      return this.availableFinishes().find((finish) => finish.id === this.state.finish);
    }

    selectedFinishOption() {
      return (this.selectedFinish()?.options || []).find((option) => option.id === this.state.finishOption);
    }

    selectedFinishVariantLabels() {
      return this.finishVariantLabels(this.selectedFinish());
    }

    finishVariantLabels(finish) {
      if (!finish) {
        return [];
      }

      return [finish?.label].concat(finish?.variantLabels || []).filter(Boolean);
    }

    selectedLining() {
      return (this.matrix.linings || []).find((lining) => lining.id === this.state.lining);
    }

    selectedStitching() {
      return (this.matrix.stitching || defaultStitching).find((stitching) => stitching.id === this.state.stitching);
    }

    selectedFitting() {
      return (this.matrix.fittings || defaultFittings).find((fitting) => fitting.id === this.state.fitting);
    }

    sizeOptionLabel(size) {
      return size?.variantLabel || size?.optionLabel || size?.label;
    }

    availableSizes() {
      const shape = this.selectedShape();
      const sizes = shape?.sizes || [];

      if (!this.variants.length) {
        return sizes;
      }

      const matrixSizes = sizes.filter((size) => (
        this.hasVariantForShapeAndSize(shape?.label, this.sizeOptionLabel(size))
      ));
      const matrixSizeLabels = new Set(matrixSizes.map((size) => normaliseSize(this.sizeOptionLabel(size))));
      const variantSizes = this.variantSizesForShape(shape?.label)
        .filter((size) => !matrixSizeLabels.has(normaliseSize(this.sizeOptionLabel(size))));

      return matrixSizes.concat(variantSizes).sort((a, b) => (
        this.sizeSortValue(a) - this.sizeSortValue(b)
      ));
    }

    variantSizesForShape(shapeLabel) {
      const normalizedShapeLabel = normalise(shapeLabel);
      const requiresShape = Boolean(shapeLabel && this.productVariantsContainOptionValue(shapeLabel));
      const seenSizes = new Set();

      return this.variants.reduce((sizes, variant) => {
        const optionValues = (variant.options || []).map(normalise);

        if (requiresShape && !optionValues.includes(normalizedShapeLabel)) {
          return sizes;
        }

        const sizeLabel = this.variantSizeLabel(variant);
        const normalizedSizeLabel = normaliseSize(sizeLabel);

        if (!sizeLabel || seenSizes.has(normalizedSizeLabel)) {
          return sizes;
        }

        seenSizes.add(normalizedSizeLabel);
        sizes.push({
          id: `variant-size-${optionIdFromLabel(sizeLabel) || sizes.length + 1}`,
          label: sizeLabel,
          variantLabel: sizeLabel,
          optionLabel: sizeLabel
        });

        return sizes;
      }, []);
    }

    variantSizeLabel(variant) {
      return (variant.options || []).find((option) => /\d/.test(String(option || ""))) || "";
    }

    sizeSortValue(size) {
      const numericSize = Number(normaliseSize(this.sizeOptionLabel(size)));

      return Number.isFinite(numericSize) ? numericSize : Number.MAX_SAFE_INTEGER;
    }

    availableFinishes() {
      const finishes = this.matrix.finishes || [];

      if (!this.variants.length) {
        return finishes;
      }

      return finishes.filter((finish) => this.hasVariantForFinish(finish));
    }

    requiredKeys() {
      const keys = ["shape", "size", "finish"];

      if (this.selectedFinish()?.options?.length) {
        keys.push("finishOption");
      }

      if (this.shouldShowStitchingStep()) {
        keys.push("stitching");
      }

      keys.push("lining");
      keys.push("fitting");

      return keys;
    }

    isComplete() {
      return this.requiredKeys().every((key) => Boolean(this.state[key]));
    }

    update() {
      if (!this.shouldShowStitchingStep()) {
        delete this.state.stitching;
      }

      this.updateStepLabels();
      this.updateSelectedDescriptions();
      this.selectedBaseVariant = null;
      this.selectedEnquiryVariant = null;
      this.activeTotal = null;

      if (!this.isComplete()) {
        this.setStatus("Choose all required options to continue.", "neutral");
        this.setSubmitState(false);
        this.writeProperties();
        return;
      }

      const variant = this.findMatchingVariant();
      const matrixPrice = this.matrixActivePrice();
      const total = this.variantActivePrice(variant) ?? matrixPrice;
      const summary = this.buildSummary();

      this.activeTotal = typeof total === "number" ? total : null;
      if (this.titleElement) {
        this.titleElement.textContent = this.dataset.productTitle;
      }
      this.summaryElement.innerHTML = this.buildSummaryHtml();
      if (this.priceElement) {
        this.priceElement.textContent = total == null ? "Unavailable" : formatMoney(total, this.moneyFormat);
      }
      this.renderSummaryPrice(variant, total);
      this.writeProperties(total, summary);
      this.updateSelectedDescriptions();

      if (total == null) {
        this.setStatus("This combination is not available.", "error");
        this.setSubmitState(false);
        return;
      }

      if (variant && !variant.available) {
        this.setStatus("This combination is currently unavailable.", "error");
        this.setSubmitState(false);
        return;
      }

      this.selectedEnquiryVariant = variant || this.currentFormVariant();

      if (!variant) {
        this.setStatus("Available to request.", "success");
        this.setSubmitState(true);
        return;
      }

      this.idInput.value = variant.id;
      this.idInput.disabled = false;
      this.selectedBaseVariant = variant;
      this.setStatus("Available to order.", "success");
      this.setSubmitState(true);
    }

    variantActivePrice(variant) {
      if (!variant) {
        return null;
      }

      return Number(variant.price || 0);
    }

    matrixActivePrice() {
      const size = this.selectedSize();
      const finish = this.selectedFinish();
      const lining = this.selectedLining();
      const stitching = this.selectedStitching();

      if (!size || !finish || !lining) {
        return null;
      }

      if (stitching && stitching.id !== "none") {
        return null;
      }

      const basePrice = size.prices?.[finish.id];

      if (basePrice == null) {
        return null;
      }

      const liningPrice = lining.id === "none" ? 0 : size.liningPrices?.[lining.id] ?? lining.price;

      if (liningPrice == null) {
        return null;
      }

      return Number(basePrice) + Number(liningPrice || 0);
    }

    renderSummaryPrice(variant, activePrice) {
      if (!this.summarySalePriceElement) {
        if (this.summaryPriceElement) {
          this.summaryPriceElement.textContent = activePrice == null ? "Unavailable" : formatMoney(activePrice, this.moneyFormat);
        }
        return;
      }

      if (activePrice == null) {
        this.summarySalePriceElement.innerHTML = '<span class="money" data-builder-summary-price>Unavailable</span>';
        this.summaryPriceElement = this.summarySalePriceElement.querySelector("[data-builder-summary-price]");
        return;
      }

      this.summarySalePriceElement.innerHTML = `
        <span class="sr-only">Regular price</span>
        <span class="money" data-builder-summary-price>${formatMoney(activePrice, this.moneyFormat)}</span>
      `;
      this.summaryPriceElement = this.summarySalePriceElement.querySelector("[data-builder-summary-price]");
    }

    buildTitle() {
      return this.interpolate(this.matrix.titleTemplate || "{size} {shape} Lampshade");
    }

    buildSummary() {
      const liningLabel = this.state.lining === "none" ? "without lining" : `with ${this.selectedLining()?.label || ""} lining`;
      const finishLabel = this.selectedFinishLabel();
      const stitchingLabel = this.state.stitching && this.state.stitching !== "none" ? ` and ${this.selectedStitching()?.label || ""}` : "";
      const fittingLabel = this.summaryFittingSentence();
      const productLabel = this.summaryProductLabel();

      return `Your selection is an ${productLabel} lampshade in the ${this.selectedSizeSummaryLabel()} size, with a ${finishLabel} finish${stitchingLabel} and ${liningLabel}.${fittingLabel}`.trim();
    }

    buildSummaryHtml() {
      const liningLabel = this.state.lining === "none" ? "without lining" : `with ${this.selectedLining()?.label || ""} lining`;
      const finishLabel = this.selectedFinishLabel();
      const stitchingLabel = this.state.stitching && this.state.stitching !== "none" ? this.selectedStitching()?.label : "";
      const fittingLabel = this.summaryFittingSentence();
      const productLabel = this.summaryProductLabel();

      return `
        Your selection is an
        <strong>${escapeHtml(productLabel)}</strong>
        <strong>lampshade</strong> in the
        <strong>${escapeHtml(this.selectedSizeSummaryLabel())}</strong>
        size, with a
        <strong>${escapeHtml(finishLabel)}</strong>
        finish${stitchingLabel ? ` and <strong>${escapeHtml(stitchingLabel)}</strong>` : ""} and
        <strong>${escapeHtml(liningLabel)}</strong>.
        ${fittingLabel ? escapeHtml(fittingLabel) : ""}
      `.replace(/\s+/g, " ").trim();
    }

    summaryProductLabel() {
      const label = String(this.dataset.productTitle || "")
        .replace(/\s+lampshades?\s*$/i, "")
        .replace(/\s+/g, " ")
        .trim();

      return label || this.selectedShape()?.label || "";
    }

    selectedSizeLabel() {
      return formatSizeLabel(this.sizeOptionLabel(this.selectedSize()));
    }

    selectedSizeSummaryLabel() {
      return formatSizeLabel(this.selectedSize()?.label);
    }

    selectedFinishLabel() {
      return uniqueLabels(this.selectedFinishOption()?.label, this.selectedFinish()?.label).join(" ");
    }

    selectedFinishStepLabel() {
      return uniqueLabels(this.selectedFinish()?.label, this.selectedFinishOption()?.label).join(" - ");
    }

    summaryFittingSentence() {
      const fitting = this.selectedFitting();

      if (!fitting) {
        return "";
      }

      if (fitting.id === "known") {
        return "We will make this to your selected fitting requirement.";
      }

      if (fitting.id === "unknown") {
        return "We will confirm the right fitting with you before making your lampshade.";
      }

      return `We will make this with your selected fitting: ${fitting.label}.`;
    }

    interpolate(template) {
      const values = {
        shape: this.selectedShape()?.label,
        size: this.selectedSizeLabel(),
        finish: this.selectedFinish()?.label,
        finishOption: this.selectedFinishOption()?.label,
        lining: this.selectedLining()?.label,
        stitching: this.selectedStitching()?.label,
        fitting: this.selectedFitting()?.label,
      };

      return template.replace(/\{(shape|size|finish|finishOption|lining|stitching|fitting)\}/g, (_match, key) => values[key] || "");
    }

    findMatchingVariant() {
      const shapeLabel = this.selectedShape()?.label;
      const sizeLabel = this.sizeOptionLabel(this.selectedSize());
      const finishLabel = this.selectedFinish()?.label;
      const finishOptionLabel = this.selectedFinishOption()?.label;
      const liningLabel = this.selectedLining()?.label;
      const stitching = this.selectedStitching();
      const hasSelectedStitching = stitching && stitching.id !== "none";
      const stitchingAllowedForFinish = !hasSelectedStitching || !stitching.finishIds?.length || stitching.finishIds.includes(this.state.finish);

      if (!stitchingAllowedForFinish) {
        return null;
      }

      const finishLabels = hasSelectedStitching
        ? (stitching.finishLabels || [
          [finishLabel, stitching.label].filter(Boolean).join(" - "),
          [finishLabel, stitching.label].filter(Boolean).join(" ")
        ])
        : [
          finishOptionLabel,
          finishLabel,
          ...this.selectedFinishVariantLabels(),
          [finishOptionLabel, finishLabel].filter(Boolean).join(" "),
          [finishLabel, finishOptionLabel].filter(Boolean).join(" ")
        ];
      const selectedLabelGroups = [
        [sizeLabel],
        finishLabels,
        [
          liningLabel,
          this.state.lining === "none" ? "Unlined" : null,
          this.state.lining === "none" ? "No lining" : null,
          this.state.lining === "none" ? "Without lining" : null
        ]
      ].map((group) => group.filter(Boolean));

      if (shapeLabel && this.productVariantsContainOptionValue(shapeLabel)) {
        selectedLabelGroups.unshift([shapeLabel]);
      }

      return this.variants.find((variant) => {
        const optionValues = (variant.options || []).map(normalise);
        const optionSizeValues = (variant.options || []).map(normaliseSize);

        return selectedLabelGroups.every((labels) => labels.some((label) => {
          const normalizedLabel = normalise(label);

          return optionValues.includes(normalizedLabel) || optionSizeValues.includes(normaliseSize(normalizedLabel));
        }));
      }) || null;
    }

    isEmpireShapeSelected() {
      const shape = this.selectedShape();

      return normalise(shape?.id) === "empire" || normalise(shape?.label).includes("empire");
    }

    isStitchingFinishOptionAllowed() {
      if (!this.isEmpireShapeSelected()) {
        return true;
      }

      return this.state.finish === "card" && empireStitchingFinishOptionIds.has(this.state.finishOption);
    }

    withTemporaryStitching(stitchingId, callback) {
      const previousStitching = this.state.stitching;

      this.state.stitching = stitchingId;

      try {
        return callback();
      } finally {
        if (previousStitching == null) {
          delete this.state.stitching;
        } else {
          this.state.stitching = previousStitching;
        }
      }
    }

    variantForStitching(stitchingId) {
      return this.withTemporaryStitching(stitchingId, () => this.findMatchingVariant());
    }

    basePriceForStitchingComparison() {
      return this.withTemporaryStitching("none", () => (
        this.variantActivePrice(this.findMatchingVariant()) ?? this.matrixActivePrice()
      ));
    }

    pricedStitchingOptions() {
      const stitchingOptions = this.matrix.stitching || defaultStitching;
      const needsFinishOption = this.isEmpireShapeSelected() || Boolean(this.selectedFinish()?.options?.length);

      if (!this.isStitchingFinishOptionAllowed() || !this.state.size || !this.state.finish || (needsFinishOption && !this.state.finishOption) || !this.state.lining) {
        return [];
      }

      const basePrice = this.basePriceForStitchingComparison();

      if (typeof basePrice !== "number") {
        return [];
      }

      return stitchingOptions.filter((stitching) => {
        if (stitching.id === "none") {
          return false;
        }

        if (stitching.finishIds?.length && !stitching.finishIds.includes(this.state.finish)) {
          return false;
        }

        const variant = this.variantForStitching(stitching.id);

        return Boolean(variant) && Number(variant.price || 0) > basePrice;
      });
    }

    shouldShowStitchingStep() {
      return this.pricedStitchingOptions().length > 0;
    }

    availableStitchingOptions(options = {}) {
      const stitchingOptions = this.matrix.stitching || defaultStitching;
      const pricedOptions = this.pricedStitchingOptions();

      if (options.includeUnavailable) {
        return stitchingOptions;
      }

      if (!pricedOptions.length) {
        return [];
      }

      return pricedOptions.concat(stitchingOptions.filter((stitching) => stitching.id === "none"));
    }

    applyDefaultStitchingSelection() {
      const options = this.availableStitchingOptions();

      if (!options.length) {
        delete this.state.stitching;
        return;
      }

      const selectedInput = this.state.stitching
        ? Array.from(this.querySelectorAll('[data-builder-choice="stitching"]')).find((input) => input.value === this.state.stitching)
        : null;

      if (selectedInput) {
        selectedInput.checked = true;
        return;
      }

      const noneInput = this.querySelector('[data-builder-choice="stitching"][value="none"]');
      const firstInput = noneInput || this.querySelector('[data-builder-choice="stitching"]');

      if (firstInput) {
        firstInput.checked = true;
        this.state.stitching = firstInput.value;
      }
    }

    hasVariantForShapeAndSize(shapeLabel, sizeLabel) {
      const normalizedShapeLabel = normalise(shapeLabel);
      const normalizedSizeLabel = normaliseSize(sizeLabel);
      const requiresShape = Boolean(shapeLabel && this.productVariantsContainOptionValue(shapeLabel));

      return this.variants.some((variant) => {
        const optionValues = (variant.options || []).map(normalise);
        const optionSizeValues = (variant.options || []).map(normaliseSize);

        return (
          (!requiresShape || optionValues.includes(normalizedShapeLabel)) &&
          Boolean(normalizedSizeLabel) &&
          optionSizeValues.includes(normalizedSizeLabel)
        );
      });
    }

    hasVariantForFinish(finish) {
      const shapeLabel = this.selectedShape()?.label;
      const sizeLabel = this.sizeOptionLabel(this.selectedSize());
      const normalizedShapeLabel = normalise(shapeLabel);
      const normalizedSizeLabel = normaliseSize(sizeLabel);
      const requiresShape = Boolean(shapeLabel && this.productVariantsContainOptionValue(shapeLabel));
      const finishLabels = this.finishVariantLabels(finish);
      const finishOptionLabels = (finish?.options || []).map((option) => option.label).filter(Boolean);
      const acceptedFinishLabels = [
        ...finishLabels,
        ...finishOptionLabels,
        ...finishOptionLabels.flatMap((optionLabel) => (
          finishLabels.flatMap((finishLabel) => [
            [optionLabel, finishLabel].filter(Boolean).join(" "),
            [finishLabel, optionLabel].filter(Boolean).join(" ")
          ])
        ))
      ].map(normalise).filter(Boolean);

      return this.variants.some((variant) => {
        const optionValues = (variant.options || []).map(normalise);
        const optionSizeValues = (variant.options || []).map(normaliseSize);

        return (
          (!requiresShape || optionValues.includes(normalizedShapeLabel)) &&
          (!normalizedSizeLabel || optionSizeValues.includes(normalizedSizeLabel)) &&
          acceptedFinishLabels.some((label) => optionValues.includes(label))
        );
      });
    }

    productVariantsContainOptionValue(label) {
      const normalizedLabel = normalise(label);

      return this.variants.some((variant) => (variant.options || []).map(normalise).includes(normalizedLabel));
    }

    updateStepLabels() {
      const labels = {
        shape: this.selectedShape()?.label,
        size: formatSizeLabel(this.selectedSize()?.label),
        finish: this.selectedFinishStepLabel(),
        lining: this.selectedLining()?.label,
        stitching: this.selectedStitching()?.label,
        fitting: this.selectedFitting()?.label,
      };

      Object.keys(labels).forEach((key) => {
        const element = this.querySelector(`[data-step-value="${key}"]`);

        if (element) {
          element.textContent = labels[key] || "Required";
        }
      });
    }

    writeProperties(total, summary) {
      const values = {
        shape: this.selectedShape()?.label || "",
        size: this.selectedSizeLabel(),
        finish: this.selectedFinish()?.label || "",
        finishOption: this.selectedFinishOption()?.label || "",
        lining: this.selectedLining()?.label || "",
        stitching: this.selectedStitching()?.label || "",
        fitting: this.selectedFitting()?.label || "",
        summary: summary || "",
        price: typeof total === "number" ? formatMoney(total, this.moneyFormat) : ""
      };

      Object.keys(values).forEach((key) => {
        const input = this.querySelector(`[data-builder-property="${key}"]`);

        if (input) {
          input.value = values[key];
        }
      });

      this.updateEnquiryLink(total, summary);
    }

    setSubmitState(enabled) {
      const buttons = Array.from(this.form?.querySelectorAll('[type="submit"]') || []);
      const paymentButtons = Array.from(this.form?.querySelectorAll(".shopify-payment-button") || []);
      const canSubmitProductForm = enabled && Boolean(this.selectedBaseVariant);

      buttons.forEach((button) => {
        button.disabled = !canSubmitProductForm;
        button.setAttribute("aria-disabled", String(!canSubmitProductForm));
      });

      paymentButtons.forEach((element) => {
        element.hidden = !canSubmitProductForm;
      });

      if (this.enquirySubmit) {
        this.enquirySubmit.setAttribute("aria-disabled", String(!enabled));

        if (!enabled) {
          this.enquirySubmit.removeAttribute("href");
        } else {
          this.updateEnquiryLink(this.activeTotal, this.buildSummary());
        }
      }

      this.toggleAttribute("data-builder-ready", enabled);
    }

    setStatus(message, tone) {
      this.statusElement.textContent = message;
      this.statusElement.dataset.tone = tone;
    }

    onKeyDown(event) {
      const input = event.target.closest("[data-builder-choice]");

      if (!input || !["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(event.key)) {
        return;
      }

      const choices = Array.from(this.querySelectorAll(`[data-builder-choice="${input.dataset.builderChoice}"]`));
      const index = choices.indexOf(input);
      let nextIndex = index;

      if (event.key === "ArrowLeft" || event.key === "ArrowUp") {
        nextIndex = Math.max(0, index - 1);
      } else if (event.key === "ArrowRight" || event.key === "ArrowDown") {
        nextIndex = Math.min(choices.length - 1, index + 1);
      } else if (event.key === "Home") {
        nextIndex = 0;
      } else if (event.key === "End") {
        nextIndex = choices.length - 1;
      }

      if (nextIndex === index || !choices[nextIndex]) {
        return;
      }

      event.preventDefault();
      choices[nextIndex].checked = true;
      choices[nextIndex].focus();
      choices[nextIndex].dispatchEvent(new Event("change", { bubbles: true }));
    }

    updateSelectedDescriptions() {
      [
        ["finishOption", this.selectedFinishOption()],
        ["lining", this.selectedLining()],
        ["stitching", this.selectedStitching()]
      ].forEach(([key, option]) => {
        const element = this.querySelector(`[data-selected-description="${key}"]`);
        const description = option?.description || option?.body || "";

        if (!element) {
          return;
        }

        element.innerHTML = description ? `<strong>${escapeHtml(option.label || "")}</strong><span>${escapeHtml(description)}</span>` : "";
        element.hidden = !description;
      });

    }

    openStitchingDetailLightbox(stitchingId = this.state.stitching) {
      const selectedStitching = (this.matrix.stitching || defaultStitching).find((stitching) => stitching.id === stitchingId);
      const imageUrl = stitchingGalleryImageFromDataset(this.dataset, stitchingId);

      if (!selectedStitching || !imageUrl) {
        return;
      }

      const imageDimensions = stitchingGalleryImageDimensions(stitchingId);
      const label = `${selectedStitching.label || "Stitching"} stitching detail`;
      let lightbox = document.querySelector("[data-builder-stitching-lightbox]");

      if (!lightbox) {
        lightbox = document.createElement("div");
        lightbox.className = "lampshade-builder__stitching-lightbox";
        lightbox.dataset.builderStitchingLightbox = "";
        lightbox.hidden = true;
        lightbox.setAttribute("role", "dialog");
        lightbox.setAttribute("aria-modal", "true");
        lightbox.innerHTML = `
          <button type="button" class="lampshade-builder__stitching-lightbox-close" data-builder-stitching-detail-close aria-label="Close stitching detail">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">
              <path d="M4 4L14 14M14 4L4 14" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"></path>
            </svg>
          </button>
          <div class="lampshade-builder__stitching-lightbox-media">
            <img data-builder-stitching-detail-image loading="eager" decoding="async">
          </div>
        `;
        document.body.append(lightbox);
        lightbox.addEventListener("click", this.onClick.bind(this));
        lightbox.addEventListener("keydown", (event) => {
          if (event.key === "Escape") {
            event.preventDefault();
            this.closeStitchingDetailLightbox();
          }
        });
      }

      const image = lightbox.querySelector("[data-builder-stitching-detail-image]");
      lightbox.setAttribute("aria-label", label);
      image.src = imageUrl;
      image.alt = label;
      image.width = imageDimensions.width;
      image.height = imageDimensions.height;
      lightbox.hidden = false;
      document.documentElement.classList.add("lock");
      lightbox.querySelector("[data-builder-stitching-detail-close]")?.focus();
    }

    closeStitchingDetailLightbox() {
      const lightbox = document.querySelector("[data-builder-stitching-lightbox]");

      if (!lightbox || lightbox.hidden) {
        return;
      }

      lightbox.hidden = true;
      document.documentElement.classList.remove("lock");
    }

    syncStitchingGalleryImage() {
      const gallery = Array.from(document.querySelectorAll("product-gallery"))
        .find((candidate) => candidate.getAttribute("form") === this.dataset.formId);
      const carousel = gallery?.querySelector(".product-gallery__carousel");

      if (!gallery || !carousel) {
        return;
      }

      const existingMedia = carousel.querySelector("[data-builder-stitching-gallery-media]");

      if (!this.hasInteractedWithStitching || !shouldSyncStitchingGallery()) {
        existingMedia?.remove();
        return;
      }

      const stitchingId = this.state.stitching;
      const imageUrl = stitchingGalleryImageFromDataset(this.dataset, stitchingId);

      if (!imageUrl) {
        existingMedia?.remove();

        const initialMedia = carousel.querySelector(".product-gallery__media.is-initial") || carousel.querySelector(".product-gallery__media:not([hidden])");
        const initialIndex = initialMedia ? carousel.cells.indexOf(initialMedia) : 0;

        if (carousel.cells?.length && initialIndex >= 0) {
          carousel.select(initialIndex, { instant: true });

          if (!carousel.isScrollable) {
            initialMedia.scrollIntoView({ block: "start", behavior: "smooth" });
          }
        }

        return;
      }

      const stitchingLabel = this.selectedStitching()?.label || "Stitching";
      const mediaId = `builder-stitching-${stitchingId}`;
      const imageDimensions = stitchingGalleryImageDimensions(stitchingId);
      let media = existingMedia;

      if (!media) {
        media = document.createElement("div");
        media.className = "product-gallery__media product-gallery__media--builder-stitching snap-center";
        media.dataset.builderStitchingGalleryMedia = "";
        media.dataset.mediaType = "image";
        media.setAttribute("role", "group");
        carousel.append(media);
      }

      media.dataset.mediaId = mediaId;
      media.setAttribute("aria-label", `${stitchingLabel} stitching preview`);
      media.innerHTML = `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(stitchingLabel)} stitching preview" loading="eager" decoding="async" width="${imageDimensions.width}" height="${imageDimensions.height}">`;
      media.removeAttribute("hidden");

      const mediaIndex = carousel.cells.indexOf(media);

      if (mediaIndex >= 0) {
        carousel.select(mediaIndex, { instant: false });

        if (!carousel.isScrollable) {
          media.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }

    async onSubmit(event) {
      if (!this.selectedBaseVariant) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      this.idInput.value = this.selectedBaseVariant.id;
      this.idInput.disabled = false;
    }

    onEnquiryClick(event) {
      if (!this.selectedEnquiryVariant || typeof this.activeTotal !== "number") {
        event.preventDefault();
        this.setStatus("Choose an available lampshade configuration before submitting your enquiry.", "error");
        this.setSubmitState(false);
        return;
      }

      this.updateEnquiryLink(this.activeTotal, this.buildSummary());
    }

    updateEnquiryLink(total, summary) {
      if (!this.enquirySubmit) {
        return;
      }

      const variant = this.selectedEnquiryVariant || this.selectedBaseVariant || this.findMatchingVariant() || this.currentFormVariant();
      if (typeof total !== "number") {
        this.enquirySubmit.removeAttribute("href");
        return;
      }

      const price = typeof total === "number" ? formatMoney(total, this.moneyFormat) : "";
      const quantity = this.quantityValue();
      const params = new URLSearchParams({
        product_handle: this.dataset.productHandle || "",
        variant_id: String(variant?.id || ""),
        builder: "lampshade",
        builder_price: price,
        builder_quantity: quantity,
        builder_sku: variant?.sku || "",
        builder_variant: variant?.title || this.buildTitle(),
        builder_shape: this.selectedShape()?.label || "",
        builder_size: this.selectedSizeLabel(),
        builder_finish: this.selectedFinish()?.label || "",
        builder_finish_option: this.selectedFinishOption()?.label || "",
        builder_lining: this.selectedLining()?.label || "",
        builder_stitching: this.selectedStitching()?.label || "",
        builder_fitting: this.selectedFitting()?.label || "",
        builder_summary: summary || ""
      });

      this.enquirySubmit.href = `/pages/request-a-quote?${params.toString()}`;
    }

    quantityValue() {
      const formQuantity = this.form?.querySelector('[name="quantity"]');
      const externalQuantity = document.querySelector(`[name="quantity"][form="${this.dataset.formId}"]`);

      return formQuantity?.value || externalQuantity?.value || "1";
    }

    openNextStep(currentKey) {
      const stepKey = currentKey === "finishOption" ? "finish" : currentKey;
      const steps = Array.from(this.querySelectorAll(".lampshade-builder__step"));
      const index = steps.findIndex((step) => step.dataset.step === stepKey);
      let nextStep = steps[index + 1] || null;

      if (currentKey === "finish" && this.selectedFinish()?.options?.length) {
        nextStep = steps[index] || null;
      }

      steps.forEach((step) => {
        step.open = step === nextStep || (step.dataset.step === "finish" && Boolean(this.state.size));
      });
    }

  }

  window.customElements.define("lampshade-product-builder", LampshadeProductBuilder);
})();
